// extracted by mini-css-extract-plugin
export default {"carditemstyle":"Dashboard_carditemstyle__IapGl","cardparagraphitemstyle":"Dashboard_cardparagraphitemstyle__oYDNl","alignEnd":"Dashboard_alignEnd__YFOq1"};